import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import TableHeaderButton from '@/metrics/components/TableHeaderButton/TableHeaderButton'
import { orderByValues } from '@/metrics/hooks/useFilters/constants'

import * as Styles from './styles'

const TableHeader = ({ nameLabel, showExchanges, onSort, orderBy }) => {
  const { t } = useTranslation()

  const isSortable = !!onSort

  const isSortingByField = field => isSortable && orderBy?.replace('-', '') === field

  const direction = orderBy?.startsWith('-') ? 'desc' : 'asc'

  const handleSortByReturns = () => onSort(orderByValues.refundCount)

  const handleSortByExchanges = () => onSort(orderByValues.exchangeCount)

  const handleSortByTotal = () => onSort(orderByValues.count)

  return (
    <Styles.Container>
      <tr>
        <th />
        <th>
          <Text type="allCapsS">{nameLabel}</Text>
        </th>
        <Styles.THAlignRight>
          <TableHeaderButton
            onClick={handleSortByReturns}
            selected={isSortingByField(orderByValues.refundCount)}
            direction={direction}
            disabled={!isSortable}
          >
            <Text type="allCapsS">{t('Devoluciones')}</Text>
          </TableHeaderButton>
        </Styles.THAlignRight>
        {showExchanges && (
          <>
            <Styles.THAlignRight>
              <TableHeaderButton
                onClick={handleSortByExchanges}
                selected={isSortingByField(orderByValues.exchangeCount)}
                direction={direction}
                disabled={!isSortable}
              >
                <Text type="allCapsS">{t('Cambios')}</Text>
              </TableHeaderButton>
            </Styles.THAlignRight>
            <Styles.THAlignRight>
              <TableHeaderButton
                onClick={handleSortByTotal}
                selected={isSortingByField(orderByValues.count)}
                direction={direction}
                disabled={!isSortable}
              >
                <Text type="allCapsS">{t('Total')}</Text>
              </TableHeaderButton>
            </Styles.THAlignRight>
          </>
        )}
      </tr>
    </Styles.Container>
  )
}

export default TableHeader
